module.exports = __webpack_public_path__ + "static/media/profile-wallet-red.41673887.svg";